import { useQuery } from "@tanstack/react-query";
import { api } from "./config";

type UseNotesRecordsParams = {
	fields: string;
	filter: any;
	sort?: string;
	enabled?: boolean;
};

export const useNotesRecords = ({ fields, filter, sort = "-date_created", enabled = true }: UseNotesRecordsParams) => {
	const query = useQuery({
		queryKey: ["notes-records", fields, filter, sort],
		queryFn: () => getNotesRecords(fields, filter, sort),
		enabled,
	});
	return query;
};

const getNotesRecords = async (fields: string, filter: any, sort: string) => {
	const { data } = await api({
		method: "GET",
		url: "/items/notes",
		params: {
			fields,
			filter: JSON.stringify(filter),
			sort,
			limit: 300,
		},
	});
	const items = data?.data ?? [];
	return items;
};
